import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomCheckBoxIcon = (
  <SvgIcon
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 20 }}
  >
    <g clipPath="url(#clip0_2111_712)">
      <rect width="20" height="20" rx="4" fill="white" />
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="3"
        stroke="#4520AB"
        strokeWidth="2"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2111_712">
        <rect width="20" height="20" rx="4" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

const CustomCheckedIcon = (
  <SvgIcon
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 20 }}
  >
    <rect width="20px" height="20px" rx="4" fill="#4520AB" />
    <path
      d="M6 9.93941L8.70833 12.6667L14.6667 6.66669"
      stroke="#F8F6FC"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export const muiCheckboxTheme = {
  MuiCheckbox: {
    defaultProps: {
      icon: CustomCheckBoxIcon,
      checkedIcon: CustomCheckedIcon,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        width: 20,
        height: 20,
        '&.MuiCheckbox-root': {
          width: 20,
          height: 20,
          padding: 4,
          '&.Mui-checked': {
            color: theme.palette.kit.background.purple,
          },
        },
      }),
    },
  },
};
